module.exports = __webpack_public_path__ + "static/media/400012_02.a6148e00.png";